import api from './axios';

export const getPainelCadastros = () => api.get('/painel-cadastros/');
